import { render } from "./NNP_ZBCD.vue?vue&type=template&id=4766e616&scoped=true"
import script from "./NNP_ZBCD.vue?vue&type=script&lang=js"
export * from "./NNP_ZBCD.vue?vue&type=script&lang=js"

import "./NNP_ZBCD.vue?vue&type=style&index=0&id=4766e616&lang=css"
import "./NNP_ZBCD.vue?vue&type=style&index=1&id=4766e616&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4766e616"]])

export default __exports__